import React, { useEffect, useState } from "react";
import {
  getUserActivity,
  getProjectActivities,
  getWorkStreamActivities,
} from "../api/Api";
import ActivityLogUI from "./ActivityLogUI";
import Pagination from "./ui/Pagination";

const ActivityLog = ({ title, type, id }) => {
  const [activities, setActivities] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pageSize] = useState(5);

  useEffect(() => {
    setLoading(true);
    setError(null);

    let fetchActivity;

    // Determine which API to call based on the type
    if (type === "user") {
      fetchActivity = getUserActivity(currentPage, pageSize);
    } else if (type === "project" && id) {
      fetchActivity = getProjectActivities(id, currentPage, pageSize);
    } else if (type === "initiative" && id) {
      fetchActivity = getWorkStreamActivities(id, currentPage, pageSize);
    } else {
      setError("Invalid activity type or missing ID.");
      setLoading(false);
      return;
    }

    // Fetch and set data
    fetchActivity
      .then((response) => {
        if (response.status === 200) {
          const activitiesData =
            response.data.activities || response.data || [];
          setActivities(activitiesData);
          setUser(response.data.user || null);

          const total =
            response.data.totalItems ||
            response.data.total ||
            response.data.count ||
            response.pagination?.total_items ||
            response.data.pagination?.total_items ||
            0;

          setTotalItems(total);
        } else {
          setError(response.message);
        }
      })
      .catch((error) => {
        setError(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [type, id, currentPage, pageSize]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="mt-4">
      <ActivityLogUI
        title={title}
        activities={activities}
        user={user}
        loading={loading}
        error={error}
      />

      {/* Show pagination only when not loading, no error, and there are items */}
      {!loading && !error && totalItems > 0 && (
        <div className="mt-3">
          <Pagination
            currentPage={currentPage}
            totalItems={totalItems}
            onPageChange={handlePageChange}
            pageSize={pageSize}
          />
        </div>
      )}
    </div>
  );
};

export default ActivityLog;
